import { render } from "./AgendaIndex.vue?vue&type=template&id=de61deae"
import script from "./AgendaIndex.vue?vue&type=script&lang=js"
export * from "./AgendaIndex.vue?vue&type=script&lang=js"

import "./AgendaIndex.vue?vue&type=style&index=0&id=de61deae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__